import configuration from "../configuration/Configuration";

class Loader {

    /**
     * Loads dynamic a vue component from /src/components dir and allows override components in /src/custom.
     * @param {string} module Component for default Template.
     * @param {string} simpleModule Component used for simple template. If unset use same like the default template.
     * @returns {Promise<Object>}
     */
    loadModule(module, simpleModule = null) {

        if (configuration.getConfig().template.overrideComponents.find(m => m === module)) {
            return import(`./../custom/components/${module}`);
        }

        if (configuration.getConfig().template.simple === true && simpleModule !== null) {
            console.log('dynamic loading module', `./../components/${simpleModule}`);
            return import(`./../components/${simpleModule}`);
        }

        return import(`./../components/${module}`);

    }

}

const moduleLoader = new Loader();
export default moduleLoader;